module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00047-fs8.d3cf76d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00047-fs8.png
// module id = 200
// module chunks = 0